import ajax from '../ajax'

// /api/salary/cost
export function CostApi(params) {
    return ajax({
        method:'get',
        url: '/api/salary/cost',
        params
    })
}


///api/salary/search

export function SearchApi(params) {
    return ajax({
        method:'get',
        url: '/api/salary/search',
        params
    })
}

//点击获取编辑页面接口
export function InfoApi(params) {
    return ajax({
        method:'get',
        url: 'api/project/info',
        params
    })
}


///api/salary/annual
export function AnnualApi(params) {
    return ajax({
        method:'get',
        url: 'api/salary/annual',
        params
    })
}

//api/salary/order
export function OrderApi(params) {
    return ajax({
        method:'get',
        url: 'api/salary/order',
        params
    })
}



///api/salary/index
export function IndexApi(params) {
    return ajax({
        method:'get',
        url: 'api/salary/index',
        params
    })
}




//api/salary/save

export function SaveApi(data) {
    return ajax({
        method:'post',
        url: '/api/salary/save',
        data
    })
}






//获取上传签名
// export function getUploadSignatureApi(data) {
//     return ajax({
//         method:'post',
//         url: 'v2/refer/sign',
//         data
//     })
// }
//开始上传
// export function startUploadApi(url,FormData) {
//     return ajax({
//         method:'post',
//         url: url,
//         data:FormData
//     })
// }

//上传完的回调
// export function completeUploadApi(params) {
//     return ajax({
//         method:'get',
//         url: 'v2/refer/finish',
//         params
//     })
// }



// WEBPACK FOOTER //
// ./src/api/salary/index.js